import * as React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import TitleScreenCrud from '../../../shared/TitleScreenCrud'
import MDInput from '../../../shared/MDInput'
import MDBox from '../../../shared/MDBox'
import MDTypography from '../../../shared/MDTypography'
import { Button, Grid, TextField, Autocomplete, Checkbox, FormControlLabel } from '@mui/material'
import professorService from '../../professorService'
import { IProfessor } from '../../ProfessorType'

const atividadesDisponiveis = ['Natação', 'Hidroginástica', 'Judô', 'Caratê', 'Ginástica', 'Dança', 'Yoga Infantil', 'Psicomotricidade']

export default function CadastroProfessorForm() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')

  const [nome, setNome] = React.useState('')
  const [cpf, setCpf] = React.useState('')
  const [telefone, setTelefone] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [especialidades, setEspecialidades] = React.useState<string[]>([])
  const [ativo, setAtivo] = React.useState(true)

  React.useEffect(() => {
    if (id) {
      professorService.getById(id).then(result => {
        if (result.data.length > 0) {
          const prof = result.data[0]
          setNome(prof.nome)
          setCpf(prof.cpf)
          setTelefone(prof.telefone)
          setEmail(prof.email)
          const esp = typeof prof.especialidades === 'string'
            ? (prof.especialidades as string).split(',').map((s: string) => s.trim()).filter(Boolean)
            : prof.especialidades || []
          setEspecialidades(esp)
          setAtivo(prof.ativo)
        }
      })
    }
  }, [id])

  const handleSalvar = async () => {
    const obj = { nome, cpf, telefone, email, especialidades: especialidades.join(', '), ativo }
    if (id) {
      await professorService.atualizar(id, obj as any)
    } else {
      await professorService.cadastrar(obj as any)
    }
    navigate('/professores')
  }

  return (
    <TitleScreenCrud title={id ? 'Editar Professor' : 'Cadastro de Professor'}>
      <MDBox padding={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="CPF"
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
              fullWidth
              placeholder="XXX.XXX.XXX-XX"
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              label="Telefone"
              value={telefone}
              onChange={(e) => setTelefone(e.target.value)}
              fullWidth
              placeholder="(XX) XXXXX-XXXX"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              type="email"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              multiple
              options={atividadesDisponiveis}
              value={especialidades}
              onChange={(_, newValue) => setEspecialidades(newValue)}
              renderInput={(params) => <TextField {...params} label="Especialidades" />}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox checked={ativo} onChange={(e) => setAtivo(e.target.checked)} />}
              label="Ativo"
            />
          </Grid>
        </Grid>
        <MDBox display="flex" gap={2} mt={3}>
          <Button
            variant="contained"
            style={{ backgroundColor: '#7b0b99', color: '#FFF', borderRadius: 8, height: 40 }}
            onClick={handleSalvar}
          >
            Salvar
          </Button>
          <Button
            variant="outlined"
            style={{ borderRadius: 8, height: 40 }}
            onClick={() => navigate('/professores')}
          >
            Cancelar
          </Button>
        </MDBox>
      </MDBox>
    </TitleScreenCrud>
  )
}
